import Vue from "vue";
import Vuetify from "vuetify";
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/dist/vuetify.min.css";
import i18n from "@/i18n";

Vue.use(Vuetify);
export default new Vuetify({
  icons: {
    iconfont: "mdi"
  },
  theme: {
    themes: {
      light: {
        primary: "#9A0000",
        secondary: "#EAAF6A",
        accent: "#b54343"
      }
    }
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  }
});
